import type { PortfolioInsight } from './portfolioInsights'

const KIND_LABEL: Record<PortfolioInsight['kind'], string> = {
  exposure: 'Exposure',
  hotspot: 'Hotspot',
  mitigation: 'Mitigation',
  single_source: 'Single-source',
  data_quality: 'Master data',
}

/**
 * Decision-led insight statements (Wave D #9/#35/#17) — not KPI restatement cards.
 */
export function InsightStatements({
  insights,
  title = 'Key insights',
}: {
  insights: PortfolioInsight[]
  title?: string
}) {
  if (insights.length === 0) return null

  return (
    <section
      className="rounded-[var(--radius-lg)] border border-es-soft bg-es-white shadow-[var(--shadow-card)] px-4 py-3.5"
      aria-label={title}
    >
      <h2 className="text-xs font-semibold uppercase tracking-wider text-es-muted mb-2.5">{title}</h2>
      <ul className="space-y-2.5">
        {insights.map((insight) => (
          <li key={insight.id} className="flex gap-3 items-start">
            <span className="shrink-0 mt-0.5 text-[10px] font-semibold uppercase tracking-wider text-es-signal min-w-[5.5rem]">
              {KIND_LABEL[insight.kind]}
            </span>
            <p className="text-sm text-es-navy leading-snug">{insight.text}</p>
          </li>
        ))}
      </ul>
    </section>
  )
}
